module.exports = __webpack_public_path__ + "static/media/img_4.7e379cb3.png";